export function addMaterialDeleteHandlers(page, coursenum) {
  $('.collapsible-sorter')
    .off('click.delete_material_button')
    .on(
      'click.delete_material_button',
      '.delete_material_button',
      function (event) {
        event.preventDefault()
        var row = $(this.closest('.customtable_row'))
        var matId = row.data('activity-id')
        $.meDialog.warningyesno(
          'Confirm',
          'Are you sure you want to delete this material?',
          function () {
            $.ajax({
              url:
                '/instructor/' +
                page +
                '.delete_materials/' +
                coursenum +
                '/' +
                matId +
                '/',
              type: 'POST',
              dataType: 'script',
              success: function (reloadTable) {
                reloadTable
                $.meDialog.topMessage(
                  'Material deleted successfully',
                  4000,
                  'success'
                )
              },
              error: function () {
                $.meDialog.topMessage(
                  'An error occurred while deleting the material',
                  4000,
                  'danger'
                )
              },
            })
          }
        ) // yesno
      }
    )
}

export function addMaterialRemoveHandlers(page, coursenum) {
  $('.collapsible-sorter')
    .off('click.remove_material_button')
    .on(
      'click.remove_material_button',
      '.remove_material_button',
      function (event) {
        event.preventDefault()
        var row = $(this.closest('.customtable_row'))
        var matId = row.data('activity-id')
        var groupId = $(this.closest('.activities_table_container'))
          .parent()
          .attr('data-groupid')
        $.meDialog.warningyesno(
          'Confirm',
          'Are you sure you want to remove this material from the text?',
          function () {
            $.ajax({
              url:
                '/instructor/' +
                page +
                '.remove_activity/' +
                coursenum +
                '/' +
                groupId +
                '/' +
                matId +
                '/',
              type: 'POST',
              dataType: 'html',
              success: function (newHtml) {
                console.log(newHtml)
                row.replaceWith(newHtml)
              },
              error: function () {
                $.meDialog.topMessage(
                  'An error occurred while removing the material from the textbook.',
                  4000,
                  'danger'
                )
              },
            })
          }
        ) // yesno
      }
    )
}
